import { loadScript } from "../../../utils/js/utils.js";
import events from "@trinitymirrordigital/chameleon-core/src/js/events";

const LOTAME_CLIENT_ID = "9458";

export function init() {
  // TODO: feature flag?
  loadLotame();
  exposeGlobal();
}

function loadLotame() {
  const dispatch = () => {
    // maybe somebody cares?
    events.fire(window, "lotame.loaded");
    // what about "lotame.id.ready" ?
  };

  loadScript(
    `https://tags.crwdcntrl.net/lt/c/${LOTAME_CLIENT_ID}/lt.min.js`
  ).then(dispatch);
}

function exposeGlobal() {
  // https://my.lotame.com/t/83hxvnt/basic-lightning-tag-implementation
  var lotameClientId = LOTAME_CLIENT_ID;
  var lotameTagInput = {
    data: {},
    config: {
      clientId: Number(lotameClientId),
    },
  };

  // Lotame initialization
  var lotameConfig = lotameTagInput.config || {};
  var namespace = (window["lotame_" + lotameConfig.clientId] = {});
  namespace.config = lotameConfig;
  namespace.data = lotameTagInput.data || {};
  namespace.cmd = namespace.cmd || [];
}
